import { createPinia, PiniaVuePlugin } from 'pinia';
import Vue from 'vue';
// import Element from 'element-ui';
import { useVuex } from '@gms/stores/src/composables/useVuex';
import { useConfigStore } from '@gms/stores/src/stores/config';
import VueMeta from 'vue-meta';

// Problem witht that is that it wont change to english
// import locale from 'element-ui/lib/locale/lang/de';
import axiosRestService from '@gms/network/src/axiosRestService';
import { Integrations } from '@sentry/tracing';
import * as Sentry from '@sentry/vue';
import { VueQueryPlugin } from '@tanstack/vue-query';
import * as Oidc from 'oidc-client-ts';
import { User, UserManager } from 'oidc-client-ts';
import * as VueGoogleMaps from 'vue2-google-maps';

import AppConfig from '../app.config';
import App from './App.vue';
import i18n from './i18n';
import vuetify from './plugins/vuetify';
import './registerServiceWorker';
import router from './router';
import store from './store';

// Inject the vuex instance into the stores library
useVuex().setVuexInstance(store);

// Globals
Vue.prototype.$audiMinPrebookTimeMins = 30;
Vue.prototype.$audiMinReservationDurationMins = 45;

// Add these to the Vue prototype to make them available globally (also for pinia stores)
Vue.prototype.$store = store;
Vue.prototype.$t = i18n.t.bind(i18n);
Vue.prototype.$tc = i18n.tc.bind(i18n);
Vue.prototype.$te = i18n.te.bind(i18n);
Vue.prototype.$d = i18n.d.bind(i18n);
Vue.prototype.$n = i18n.n.bind(i18n);
const pinia = createPinia()
Vue.prototype.$pinia = pinia

Vue.config.productionTip = false;
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});

Vue.use(VueQueryPlugin)
Vue.use(PiniaVuePlugin);

// hostname gives us the domain part of the url without the port
// e.g. http://localhost:8081 -> localhost
// e.g. https://admin.audi.book-n-park.de -> admin.audi.book-n-park.de
const { hostname } = window.location;
const [configKey, config] = Object.entries(AppConfig).find(([key, _]) => AppConfig[key].urls.some((url) => url.test(hostname))) ?? ['', AppConfig[0]];
console.log('hostname is', hostname, 'therefore using config', configKey);

Vue.directive('scroll', {
  inserted(el, binding) {
    function f(evt: Event) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f);
      }
    }

    window.addEventListener('scroll', f);
  },
});

if (
  process.env.NODE_ENV === 'production'
    && window.location.hostname.endsWith('staging.booknpark.de')
) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DNS,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['*.booknpark.de', '*.book-n-park.de'],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

const app = new Vue({
  router,
  store,
  vuetify,
  i18n,
  pinia,

  render: (h) => h(App),
}).$mount('#app');

const configStore = useConfigStore();
if (!config.isDev || configStore.config === undefined) {
  // Only override the config loaded from local storage in
  // prod or if we don't have one yet
  configStore.config = config
} else if (config.isDev) {
  // Merge new default values if we are in dev
  configStore.config = { ...config, ...configStore.config }
}

async function loadMaps() {
  await store.restored;
  Vue.use(VueGoogleMaps, {
    load: {
      key: configStore.config?.googleMapsKey,
      libraries: 'places',
      region: 'DE',
      language: store.getters.language,
    },
  });
}

loadMaps();

Oidc.Log.setLogger(console);
Oidc.Log.setLevel(Oidc.Log.DEBUG);
console.log('in main.ts')
console.log(window.location);
const url = `${window.location.protocol}//${window.location.host}/auth`
console.log('Callback URL')
console.log(url)
if (!Vue.prototype.$audiOidcUserManager) {
  console.log('Initializing new user manager')
  Vue.prototype.$audiOidcUserManager = new UserManager({
    authority: 'https://identity.vwgroup.io',
    client_id: '34ff0454-483c-4c80-9bc1-796107f11ea1@apps_vw-dilab_com',
    redirect_uri: url,
    client_secret: '3e2e4eeb61ca6c901e8a5b2ab83c5dc8c19548b52816b1932f5d4230daec3c34',
  })
}
Vue.prototype.$audiOidcUserManager.getUser().then((user: User | null) => {
  if (user?.access_token) {
    axiosRestService.setBearerToken(user.access_token)
  }
})

async function setLanguage() {
  await store.restored;
  i18n.locale = store.getters.language;

  // We don't want to update the database on the login page, since the user isn't logged in yet
  store.dispatch('translateToWithoutDB', store.getters.language);
}

async function clearOldNotifications() {
  await store.restored;
  store.dispatch('notifications/removeOldNotifications', store.getters.notifications);
  store.commit('oidcRegister/setShowVwBnPMappingDialogue', false);
}

setLanguage();
clearOldNotifications();

function updateAxios(configState: typeof configStore.$state) {
  axiosRestService.setClientId(configState.config?.api.clientId ?? '')
  axiosRestService.setBaseUrl(configState.config?.api.baseUrl ?? '')
}

updateAxios(configStore)

configStore.$subscribe((mutation, state) => {
  updateAxios(state)
})
